import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { connect } from "react-redux";
import Spinner from "../../components/Spinner/Spinner";
import { fetchApi } from "../../Utils/Connections";

const mapStateToProps = (state: any) => {
  return {
    path: state.path,
    validCode: state.validCode,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    setPath: (path: string) => dispatch({ type: "SET_PATH", payload: path }),
    setValidCode: (valid: boolean) =>
      dispatch({ type: "SET_VALID_CODE", payload: valid }),
  };
};

const Register = ({ path, setPath, setValidCode, validCode }: any) => {
  const [showCode, setShowCode] = React.useState<boolean>(false);
  const [code, setCode] = React.useState<string>("");
  const [loading, setLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string>("");
  const navigate = useNavigate();

  const register = async () => {
    const trimmed = code.trim();
    if (!trimmed) {
      setError("Please enter your membership code.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const result = await fetchApi(
        `Public/GetUserByCode?Code=${encodeURIComponent(trimmed)}`,
        "GET",
        {}
      );
      if (result.StatusCode === 200 && result.My_Result) {
        sessionStorage.setItem("code", trimmed);
        sessionStorage.setItem("member", JSON.stringify(result.My_Result));
        sessionStorage.setItem("valid", "true");
        setValidCode(true);
      } else {
        // ExceptionMsg can be a raw database error, so it is logged rather than shown
        console.warn("Membership code rejected", result?.StatusCode, result?.ExceptionMsg);
        setError("Invalid membership code.");
      }
    } catch (e) {
      console.warn("Membership code check failed", e);
      setError("Could not reach the server. Check your connection and try again.");
    } finally {
      setLoading(false);
      scrollToTop();
    }
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  React.useEffect(() => {
    sessionStorage.setItem("selectedRoute", "/");
    setPath("/");
  }, [setPath]);

  useEffect(() => {
    if (validCode) {
      sessionStorage.setItem("selectedRoute", "/home");
      setPath("/home");
      navigate("/home");
    }
  }, [validCode, navigate, setPath]);

  return (
    <div className="bg-light">
      <div className="h-100 d-flex justify-content-center p-3 ">
        <img src="/assets/images/icdrlogo.png" alt="" className="mw-100" />
      </div>
      {loading && (
        <div className="d-flex justify-content-center pb-5">
          <Spinner />
        </div>
      )}
      <div className="container d-flex align-items-center pt-1 mb-4 ">
        <input
          type={showCode ? "text" : "password"}
          className="form-control rounded"
          value={code}
          placeholder="Enter your Membership Code"
          onChange={(e) => setCode(e.target.value)}
        />
        <i
          className={`bi bi-eye${showCode ? "-slash" : ""}`}
          onClick={() => setShowCode(!showCode)}
          style={{ marginLeft: "-2rem", padding: "0.5rem" }}></i>
        <button
          className="btn mx-2 btn-primary rounded"
          style={{ padding: "0.65rem" }}
          onClick={() => {
            register();
          }}
          disabled={loading}>
          Check
        </button>
      </div>
      {error && (
        <div className="container text-danger pb-4" role="alert">
          {error}
        </div>
      )}
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);
